const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.8,26c-3.1-5.2-10.8-5.1-13.4-5.1l-1.2,0c-2.5,0-10-0.1-13.1,5.1c-0.4,0.6-0.2,1.4,0.5,1.8 C0.9,27.9,1.1,28,1.3,28c0.5,0,0.9-0.2,1.1-0.7c2.3-3.9,8.7-3.8,10.8-3.8l1.2,0c2.1,0,8.7-0.1,11,3.8c0.2,0.4,0.7,0.7,1.1,0.7 c0.2,0,0.5-0.1,0.7-0.2C28,27.5,28.2,26.6,27.8,26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M14,17.8c4.9,0,9-4,9-8.9C23,4,18.9,0,14,0C9.1,0,5,4,5,8.9C5,13.8,9.1,17.8,14,17.8z M7.7,8.9 c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3c0,3.5-2.8,6.3-6.3,6.3C10.5,15.2,7.7,12.3,7.7,8.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.76fa9b3273a109e7d7a0402b91e765ec.svg";
export { ForwardRef as ReactComponent };